/**
 * Gestoria Moreno - v1.0.0
 * Política de Privacidad (RGPD)
 */

import { useEffect } from "react";
import Container from "@mui/material/Container";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";
import SEO from "components/SEO";

import routes from "routes";
import footerRoutes from "footer.routes";
import logoImg from "assets/images/logo.png";

function PoliticaPrivacidad() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEO
        title="Política de Privacidad - Gestoría Moreno Granada"
        description="Política de privacidad de Gestorías Moreno Martín Alhambra S.L.P. Información sobre el tratamiento de datos personales conforme al RGPD."
        canonicalUrl="/politica-privacidad"
        robots="noindex, follow"
      />
      <MKBox position="fixed" top="0.5rem" width="100%" sx={{ zIndex: 9999 }}>
        <DefaultNavbar
          brand={
            <img
              src={logoImg}
              alt="Logo Gestoría Moreno"
              width="106"
              height="50"
              style={{
                height: "50px",
                width: "auto",
                imageRendering: "-webkit-optimize-contrast",
              }}
            />
          }
          routes={routes}
          sticky
        />
      </MKBox>
      <MKBox pt={18} pb={6} px={3}>
        <Container sx={{ maxWidth: "900px !important" }}>
          <MKTypography variant="h2" mb={4}>
            Política de Privacidad
          </MKTypography>

          <MKTypography variant="body2" color="text" mb={3}>
            En Gestorías Moreno Martín Alhambra S.L.P. nos comprometemos a proteger sus datos
            personales. Esta política de privacidad explica cómo recopilamos, usamos y protegemos su
            información, conforme al Reglamento General de Protección de Datos (RGPD) y a la Ley
            Orgánica de Protección de Datos Personales y garantías de los derechos digitales
            (LOPDGDD).
          </MKTypography>

          <MKTypography variant="h3" mb={1}>
            1. Responsable del tratamiento
          </MKTypography>
          <MKTypography variant="body2" color="text" mb={3}>
            <strong>Gestorías Moreno Martín Alhambra S.L.P.</strong>
            <br />
            <strong>CIF:</strong> B18492264
            <br />
            <strong>Domicilio:</strong> Avenida Divina Pastora, 9, local 13, 18012 Granada
            <br />
            <strong>Teléfono:</strong> 958 805 110
            <br />
            <strong>Email:</strong> info@gestoriamoreno.com
            <br />
            <strong>Actividad:</strong> Servicios de gestoría administrativa, asesoría fiscal,
            laboral y contable
          </MKTypography>

          <MKTypography variant="h3" mb={1}>
            2. Datos que recopilamos
          </MKTypography>
          <MKTypography variant="body2" color="text" mb={3}>
            A través de nuestro formulario de contacto, podemos recopilar los siguientes datos:
            <br />
            <br />- <strong>Identificación:</strong> Nombre completo
            <br />- <strong>Contacto:</strong> Dirección de email y, opcionalmente, número de
            teléfono
            <br />- <strong>Consulta:</strong> Mensaje con la consulta o solicitud de información
            <br />
            <br />
            No recopilamos datos personales de menores de 14 años. En caso de que detectemos que un
            menor ha proporcionado datos sin autorización paterna, procederemos a su eliminación
            inmediata.
          </MKTypography>

          <MKTypography variant="h3" mb={1}>
            3. Finalidad del tratamiento de datos
          </MKTypography>
          <MKTypography variant="body2" color="text" mb={3}>
            Los datos personales que nos facilite serán tratados con las siguientes finalidades:
            <br />
            <br />- <strong>Gestión de consultas:</strong> Atender y responder a sus consultas y
            solicitudes de información.
            <br />- <strong>Relación comercial:</strong> Gestionar la relación profesional y
            contractual con nuestros clientes.
            <br />- <strong>Obligaciones legales:</strong> Cumplir con las obligaciones fiscales,
            laborales y contables derivadas de nuestra actividad profesional.
            <br />- <strong>Comunicaciones:</strong> Enviar comunicaciones relacionadas con nuestros
            servicios, previo consentimiento expreso.
          </MKTypography>

          <MKTypography variant="h3" mb={1}>
            4. Legitimación
          </MKTypography>
          <MKTypography variant="body2" color="text" mb={3}>
            La base legal para el tratamiento de sus datos es:
            <br />
            <br />- <strong>Consentimiento:</strong> Del interesado al enviar el formulario de
            contacto (art. 6.1.a RGPD).
            <br />- <strong>Ejecución contractual:</strong> En el caso de clientes, para la
            prestación de nuestros servicios (art. 6.1.b RGPD).
            <br />- <strong>Obligación legal:</strong> Cumplimiento de obligaciones fiscales,
            laborales y contables (art. 6.1.c RGPD).
            <br />- <strong>Interés legítimo:</strong> Para el envío de comunicaciones comerciales
            relacionadas con nuestra actividad, cuando se haya establecido una relación previa (art.
            6.1.f RGPD).
          </MKTypography>

          <MKTypography variant="h3" mb={1}>
            5. Destinatarios de los datos
          </MKTypography>
          <MKTypography variant="body2" color="text" mb={3}>
            Sus datos no serán cedidos a terceros, salvo obligación legal. Podrán comunicarse a:
            <br />
            <br />- <strong>Administraciones públicas:</strong> Agencia Tributaria, Seguridad Social
            y otros organismos, en cumplimiento de obligaciones legales.
          </MKTypography>

          <MKTypography variant="h3" mb={1}>
            6. Conservación de los datos
          </MKTypography>
          <MKTypography variant="body2" color="text" mb={3}>
            Los datos personales se conservarán durante los siguientes plazos:
            <br />
            <br />- <strong>Consultas:</strong> Los datos de contacto se conservarán durante 1 año
            desde la última comunicación, salvo que se solicite su supresión.
            <br />- <strong>Clientes:</strong> Los datos se conservarán mientras dure la relación
            contractual y durante los plazos legales aplicables (hasta 4 años para obligaciones
            fiscales y 6 años para contabilidad, conforme a la normativa vigente).
          </MKTypography>

          <MKTypography variant="h3" mb={1}>
            7. Derechos del interesado
          </MKTypography>
          <MKTypography variant="body2" color="text" mb={3}>
            Usted tiene derecho a:
            <br />
            <br />- <strong>Acceso:</strong> Solicitar información sobre los datos personales que
            tenemos sobre usted.
            <br />- <strong>Rectificación:</strong> Solicitar la corrección de datos inexactos.
            <br />- <strong>Supresión:</strong> Solicitar la eliminación de sus datos cuando ya no
            sean necesarios.
            <br />- <strong>Limitación:</strong> Solicitar la restricción del tratamiento de sus
            datos en determinadas circunstancias.
            <br />- <strong>Portabilidad:</strong> Solicitar recibir sus datos en formato
            estructurado y transmitirlos a otro responsable.
            <br />- <strong>Oposición:</strong> Oponerse al tratamiento de sus datos cuando la base
            legal sea el interés legítimo.
            <br />- <strong>Retirada del consentimiento:</strong> En cualquier momento, cuando el
            tratamiento se base en su consentimiento, sin que ello afecte a la licitud del
            tratamiento previo.
            <br />
            <br />
            Para ejercer estos derechos puede dirigirse a: <strong>info@gestoriamoreno.com</strong>,
            indicando en el asunto &quot;Protección de Datos&quot;. Podremos solicitar documentación
            acreditativa de identidad cuando resulte necesario.
            <br />
            <br />
            Responderemos a su solicitud en el plazo máximo de un mes, conforme al artículo 12 del
            RGPD.
            <br />
            <br />
            Asimismo, tiene derecho a presentar una reclamación ante la Agencia Española de
            Protección de Datos (www.aepd.es) si considera que el tratamiento de sus datos infringe
            la normativa vigente.
          </MKTypography>

          <MKTypography variant="h3" mb={1}>
            8. Cookies
          </MKTypography>
          <MKTypography variant="body2" color="text" mb={3}>
            Este sitio web utiliza cookies de análisis (Google Analytics) para mejorar la
            experiencia de navegación y comprendre cómo los usuarios interactúan con el sitio.
            <br />
            <br />
            Puede configurar su navegador para rechazar las cookies, aunque ello pueda afectar a la
            funcionalidad del sitio.
          </MKTypography>

          <MKTypography variant="h3" mb={1}>
            9. Seguridad de los datos
          </MKTypography>
          <MKTypography variant="body2" color="text" mb={3}>
            Gestorías Moreno Martín Alhambra S.L.P. adopta las medidas técnicas y organizativas
            necesarias para garantizar la seguridad de los datos personales y evitar su alteración,
            pérdida, tratamiento o acceso no autorizado, conforme a lo establecido en el artículo 32
            del RGPD.
            <br />
            <br />
            El sitio web utiliza certificado SSL/TLS para cifrar las comunicaciones entre su
            navegador y nuestros servidores.
          </MKTypography>

          <MKTypography variant="h3" mb={1}>
            10. Modificaciones
          </MKTypography>
          <MKTypography variant="body2" color="text" mb={3}>
            Nos reservamos el derecho de modificar esta política de privacidad para adaptarla a las
            novedades legislativas o a las prácticas de nuestra empresa. Cualquier cambio será
            publicado en esta página con la fecha de última actualización.
          </MKTypography>

          <MKTypography variant="caption" color="text">
            Última actualización: Junio 2026
          </MKTypography>
        </Container>
      </MKBox>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default PoliticaPrivacidad;
